export default __webpack_public_path__ + "static/media/service-1.66433501.jpg";